import React from 'react';
import Autocomplete from 'react-autocomplete'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { keys, sortBy, some } from 'lodash'
import './index.css'


const menuStyle ={
  backgroundColor:'#fff',
  padding: '2px 0',
  magin: '0px',
  position: 'absolute',
  overflow: 'auto',
  maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
  color: "#222",
  width: "auto",
  fontSize: '14px',
  border: "solid #ccc 1px",
  borderTop: "none",
}


class DataExplorerSearch extends React.PureComponent {

  state = {
    value: ''
  }

  render(){

    const { countries, indicators, tfaMeta, inputProps={}} = this.props
    const value = this.state.value

    const itemsCountries = keys(countries)
    .map(code => ({ group:'COUNTRY', label:countries[code], value:code, search:[code, countries[code]], path:`/countries/${code}` }))

    const itemsTfa = keys(tfaMeta)
    .map(code => ({ group:'TFA', label:`Article ${code}`, value:code, search:[code, `Article ${code}`], path:`/tfa/${code}` }))

    const itemsIndicators = keys(indicators)
    .map(code => ({ group:'WEF', label:indicators[code].shortTitle, value:code, search:[code, indicators[code].shortTitle], path:`/topics/${code}` }))
    .filter(x => x.label)

    const items = sortBy(itemsCountries.concat(itemsIndicators).concat(itemsTfa), 'label')

    return (

      <Autocomplete
         getItemValue={(item) => item.value}
         menuStyle={menuStyle}
         inputProps={inputProps}
         items={items.sort(i => i.label)}
         shouldItemRender={(item, value)=>{
           const truthy = item.search.map(x => x.toLowerCase().indexOf(value.toLowerCase()) !== -1)
           return some(truthy)
         }}
         renderItem={(item, isHighlighted) =>
           <Link className="no-underline link-blue" to={item.path}>
             <div className="pa1" style={{ background: isHighlighted ? 'lightgray' : '#fff' }}>
               [{item.group}] {item.label}
             </div>
           </Link>
         }
         value={value}
         onChange={(e) => this.setState({value:e.target.value}) }
         onSelect={(val) => {

         } }

       />
    )
  }
}


const mapStateToProps = (state) => ({
  countries: state.countries,
  indicators: state.indicators,
  tfaMeta: state.tfaMeta,
})


export default connect(mapStateToProps)(DataExplorerSearch)



// WEBPACK FOOTER //
// ./src/components/DataExplorerSearch/index.js